export default "__VITE_ASSET__t69QpUdA__"